export default __webpack_public_path__ + "static/media/CNo.73-6.2a02591c.jpg";